import { createClient } from '@urql/vue';

const client = createClient({
  url: '/api/v2/graphql',
});

export default client;
